module.exports = __webpack_public_path__ + "static/media/main-slider-3.3ca3f0f5.png";